// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout_layout__qOGZg","sider":"DashboardLayout_sider__9ro23","content":"DashboardLayout_content__UJxy-"};